import { render, staticRenderFns } from "./Advert.vue?vue&type=template&id=42f43a0a&scoped=true&"
import script from "./Advert.vue?vue&type=script&lang=js&"
export * from "./Advert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f43a0a",
  null
  
)

export default component.exports